import types from './constants'

export default {
  [types.SKILLSDIAGNOSTIC_PENDING]: () => ({
   type: types.SKILLSDIAGNOSTIC_PENDING,
  }),
  [types.SKILLSDIAGNOSTIC_COMPLETE]: (report, activities) => ({
   type: types.SKILLSDIAGNOSTIC_COMPLETE,
   report,
  }),
  [types.SKILLSDIAGNOSTIC_ERROR]: (error) => ({
   type: types.SKILLSDIAGNOSTIC_ERROR,
   error
  }),
}